// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yvPk6","copy":"styles_copy__9lO8c","home":"styles_home__5Mn5B"};